import React from "react";
import './Footer.css'

const Footer = () => (
  <footer className="footer">
    <p>© 2024 MegaLoto. Todos los derechos reservados.</p>
    <p>
      Contáctanos: <a href="mailto:megaloto.2024@gmail.com">sorteotimmerbudao@megaloto.com</a>
    </p>
    <div className="social-icons">
      {/* Agregar iconos de redes sociales */}
    </div>
  </footer>
);

export default Footer;
